// extracted by mini-css-extract-plugin
module.exports = {"container":"CommonEntryDetail_container__VQXzu","createContainer":"CommonEntryDetail_createContainer__2B8I6","variantContainer":"CommonEntryDetail_variantContainer__FIfJH"};